"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var selection_1 = require("../selection");

var TOGGLE = '_toggle';
var toggle = {
  has: function has(selCmpt) {
    return selCmpt.type === 'multi' && selCmpt.toggle;
  },
  signals: function signals(model, selCmpt, _signals) {
    return _signals.concat({
      name: selCmpt.name + TOGGLE,
      value: false,
      on: [{
        events: selCmpt.events,
        update: selCmpt.toggle
      }]
    });
  },
  modifyExpr: function modifyExpr(model, selCmpt, expr) {
    var tpl = selCmpt.name + selection_1.TUPLE;
    var signal = selCmpt.name + TOGGLE;
    return signal + " ? null : " + tpl + ", " + (selCmpt.resolve === 'global' ? signal + " ? null : true, " : signal + " ? null : {unit: " + selection_1.unitName(model) + "}, ") + (signal + " ? " + tpl + " : null");
  }
};
exports.default = toggle;